module.exports = __webpack_public_path__ + "img/Bic_Camera_EN.b03c2b68.png";